import { getPageViewEventProfileData } from '../../utils/helpers/get-page-view-event-profile-data';

import { PageViewEventClient } from './page-view-event-client';
import { type PageViewEventProps } from './types';

export const PageViewEventServer = async (props: PageViewEventProps) => {
  const profileData = await getPageViewEventProfileData();

  return <PageViewEventClient {...props} profileData={profileData} />;
};
